import React from 'react';
import Axios from 'axios';

import moment from 'moment';
import Users from '../../users/Users';

import QvneaBooksOperations from './QvneaBooksOperations';
import QvneaBooksSummary from './QvneaBooksSummary';
import QvneaBooksPlayerAccount from './QvneaBooksPlayerAccount';


const ADMIN_LVL_MASTER = 0;				// same as Users.js
const ADMIN_LVL_ADMINLIMIT = 20;	// same as Users.js

class QvneaBooks extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			pageOption: "operations",

			// admin players
	    isAuthenticated: this.props.auth.isAuthenticated(),
			profile: this.props.auth.getProfile(),
			adminAccess: {
				auth: this.props.auth,
				globalAccessLevel: 99,
				adminValidatedAccessLevel: 99		// not used here
			},
			isAdmin: false,
		};

		this.summaryButtonClicked = this.summaryButtonClicked.bind(this);
		this.operationsButtonClicked = this.operationsButtonClicked.bind(this);
		this.playerAccountButtonClicked = this.playerAccountButtonClicked.bind(this);
	}

	componentDidMount() {
		// console.log('MontQvnea: componentDidMount');
		this.initiateData();
	}

	UNSAFE_componentWillReceiveProps() {
		// console.log('MontQvnea: UNSAFE_componentWillReceiveProps');
	}

	initiateData() {
		var _this = this;

		// get admin rights
		this.getAdminRightsInfo(function(adminAccess) {
		Users.getCharterAdmin(_this.state.profile, function(charterAdmin) {

			// isAdmin status
	  	var isAdmin = (adminAccess.globalAccessLevel <= ADMIN_LVL_ADMINLIMIT);

	  	// ################   ACCESS   ###################
			if (!isAdmin || (charterAdmin.indexOf('QVNEA-MASTER') === -1)) {
				console.log('QVNEA BOOKS: ACCESS DENIED!');
				_this.props.history.push('/');
				return;
			}

  		// generate Years selector
			_this.setState({
				adminAccess: adminAccess,
				isAdmin: isAdmin,
			});
		});
		});
	}

	render() {
		// console.log('QvneaBooks: render');

		var _this = this;

		var summaryBtnClass = 'btn-primary';
		var operationsBtnClass = 'btn-primary';
		var playerAccountBtnClass = 'btn-primary';

		if (this.state.pageOption === "operations") {
			summaryBtnClass = 'btn-secondary';			
			playerAccountBtnClass = 'btn-secondary';	

		} else if (this.state.pageOption === "summary") {
			operationsBtnClass = 'btn-secondary';
			playerAccountBtnClass = 'btn-secondary';

		} else {
			summaryBtnClass = 'btn-secondary';			
			operationsBtnClass = 'btn-secondary';
		}


		return (
			<div className="animated fadeIn">
        <div className="row">
        <div className="col-12">
          <h4>QVNEA Finances</h4>
          <p>LA PUISSANCE DES STATS</p>
	        <hr/>
				</div>
				</div>

				<div className="row">
				<div className="col-md-12">
					<button className={"btn " + operationsBtnClass + " btn-margin-right-10"} onClick={this.operationsButtonClicked}>
						QVNEA Opérations
					</button>

					<button className={"btn " + summaryBtnClass + " btn-margin-right-10"} onClick={this.summaryButtonClicked}>
						QVNEA Sommaire
					</button>

					<button className={"btn " + playerAccountBtnClass + " btn-margin-right-10"} onClick={this.playerAccountButtonClicked}>
						QVNEA Compte Joueur
					</button>

					<br/><br/>
				</div>
				</div>

				{(this.state.pageOption === "operations") ? 
					<QvneaBooksOperations history={this.props.history} auth={this.props.auth} /> 
					: null}

				{(this.state.pageOption === "summary") ? 
					<QvneaBooksSummary auth={this.props.auth} /> 
					: null}

				{(this.state.pageOption === "playerAccount") ? 
					<QvneaBooksPlayerAccount auth={this.props.auth} profile={this.state.profile} /> 
					: null}

      </div>
		);
	}

	summaryButtonClicked() {
		if (this.state.pageOption !== "summary") {
			this.setState({
				pageOption: "summary"
			});
		}
	}

	operationsButtonClicked() {
		if (this.state.pageOption !== "operations") {
			this.setState({
				pageOption: "operations"
			});
		}
	}

	playerAccountButtonClicked() {
		if (this.state.pageOption !== "playerAccount") {
			this.setState({
				pageOption: "playerAccount"
			});
		}
	}

	getAdminRightsInfo(callback) {
		var adminAccess = this.state.adminAccess;
		adminAccess.adminValidatedAccessLevel = 99;		// not used here

		if (this.state.isAuthenticated) {
			Users.getAccessLevel(this.state.profile, function(globalAccessLevel) {
				adminAccess.globalAccessLevel = globalAccessLevel;
				callback(adminAccess);
			});

		} else {
			adminAccess.globalAccessLevel = 99;
			callback(adminAccess);
		}
	}

}

export default QvneaBooks;
